import React from 'react';
import type ServicedeskKnowledgeHubViewArticleType from '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-view-article/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubViewArticle = lazyForPaint<
	typeof ServicedeskKnowledgeHubViewArticleType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-knowledge-hub-view-article", jiraSpaEntry: "async-servicedesk-knowledge-hub-view-article" */ '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-view-article'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubViewArticle}
		pageId="spa-apps/servicedesk/knowledge-hub/view-article"
		shouldShowSpinner
	/>
);
